import { CodeBlockWrapper } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  CodeBlockWrapper,
  React
};